<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => pageTitle = val" />
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap">
                <article class="srch_basic">
                    <div class="srch_grup">
                        <ul class="w50">
                            <li class="tit_150">{{$t('FIELD.GLOBAL.SUBSIDIARY')}} <em class="txt_mandatory">*</em></li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_2">
                                    <div>
                                        <select class="slt_white w100" v-model="rhqCd" @change="changeRhqCd()">
                                            <option v-if="rhqCdList.length > 1" value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100" v-model="corpNo">
                                            <option v-if="corpNoList.length != 1" value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w50">
                            <li class="tit_150">{{$t('FIELD.GLOBAL.PERIOD')}} <em class="txt_mandatory">*</em></li>
                            <li data-input-type="date" class="w100-150">
                                <fieldset class="ui_fieldset">
                                    <span class="date-wrap">
                                        <label>
                                            <input id="toDate" type="text" placeholder="To Date" @blur="refineColumns()" class="date_input w100p" readonly>
                                            <a href="javascript:" id="icoToDate" class="in_btn">
                                                <i class="ico_date"></i>
                                                <span class="sr_only">종료월</span>
                                            </a>
                                        </label>
                                        <div id="to-picker-container" style="margin-top: -1px;" />
                                    </span>
                                </fieldset>
                            </li>
                        </ul>                
                    </div>
                    <div class="srch_grupR_bottom">
                        <span class="btn">
                            <a href="javascript:" class="btn_srch" @click="onSearch()">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                        </span>
                    </div>
                </article>
            </div>
            <!-- Grid -->
            <!-- Grid -->
            <div class="grid_wrap">
                <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ totalCount | numberFormat }}</em></div>
                <div class="btn_wrap">
                    <a href="javascript:" class="btn_white" @click="excelDownload()">{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    :data="gridData"
                    ref="GridId"
                    :columns="columns"
                    :options="options"
                    :header="gridHeader"
                    :key="gridKey"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue                      from 'vue';
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import $                        from 'jquery';
import qs                       from 'query-string';
import api                      from '@/service';
import axios                    from 'axios';
import moment                   from 'moment';
import { SDLUtil, DateUtil }    from '@/utils';
import SKPBreadcrumbs           from '~vb/main/SKPBreadcrumbs';
import DatePicker               from '~c/DatePicker';
import ToastGrid                from '~c/ToastGrid';
import ExcelDownloadPopup       from '~vb/common/ExcelDownloadPopup';

require('moment-jdateformatparser');

// 메인 목록 조회
const fetchGridData = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/statisticsManager/getMonthlySatisfactions.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// ToastGrid Tooltip renderer
class TooltipRenderer {
    constructor(props) {
        let resVal = props.value;
        const el = document.createElement('span');
        el.innerText = resVal;
        el.title = resVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
};

export default {
    name : 'UnreadList',
    props : {

    },
    data() {
        return {
            isProcess: true,
            rhqCd: '',
            corpNo: '',
            TO_DATE: {},       // End Date
            rhqCdList: [],
            corpNoList: [],
            searchParam: {},
            
            pageTitle : '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            totalCount : 0,
            gridId : "GridId",
            gridKey: 0,
            gridData : [],
            columns : [],
            gridHeader: {},
            options : {
                scrollX: false,
                scrollY: false,
                header: { height: 45 },
                rowHeight: 45,
            },
            pageOptions : {},
        }
    },
    computed: {
        ...mapGetters({
            params:     'getParams',
            loginNo:    'getLoginNo',
        }),
        getLoginNo() {
            return this.loginNo || '';
        },
    },
    components: {
        'skp-breadcrumbs' : SKPBreadcrumbs,
        'toast-grid' : ToastGrid
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        loadSubsiCodes(mode, pCode) {
            if (mode == 1) {
                // RhqCd
                this.getCodeComboList(this.getLoginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                    this.rhqCdList = data;
                    this.rhqCd = this.rhqCdList[0].code;
//                    if (this.rhqCdList.length == 1) this.rhqCd = this.rhqCdList[0].code;
//                    else                            this.rhqCd = '';
                    if (this.rhqCd) this.loadSubsiCodes(2, this.rhqCdList[0].code);
                });
            } else if (mode == 2) {
                // CorpNo
                this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                    this.corpNoList = data;
                    this.corpNo = this.corpNoList[0].code;
//                    if (this.corpNoList.length == 1) this.corpNo = this.corpNoList[0].code;
//                    else                             this.corpNo = '';
                });
            }
        },
        changeRhqCd() {
            if (this.rhqCd == '') {
                this.corpNoList = [];
                this.corpNo = '';
            } else {
                this.loadSubsiCodes(2, this.rhqCd);
            }
        },
        getSearchParams() {
            let params = {
                rhqCd : this.rhqCd,
                corpNo : this.corpNo,
                toMonth : this.TO_DATE.getDate() ? moment(this.TO_DATE.getDate()).formatWithJDF(moment().toMomentFormatString('yyyyMM')) : ''
            };

            let columnIds = [];
            let columnNames = [];
            let columnAligns = [];
            this.columns.forEach(elm => {
                columnIds.push(elm.name);
                columnNames.push(elm.header.replace(/\'/g, '20'));
                columnAligns.push((elm.align || 'L').replace('center', 'C'));
            });
            params.columnIds    = columnIds;
            params.columnNames  = columnNames;
            params.columnAligns = columnAligns;
            return params;
        },

        // 버튼 이벤트
        async onSearch() {
            if (this.rhqCd.length == 0) {
                SDLUtil.alert('MESSAGE.GROBAL.SELECT.SUBSIDIARY');
                return;
            }
            let params = this.getSearchParams();
            params.queryId = 'selectMonthlyQnaStatuses';
            SDLUtil.showLoadingBar(true);
            const response = await fetchGridData(params)
                .then(res => {
                    this.gridData = res.data.rows;
                    this.totalCount = res.data.totalCount;
                    this.searchParam = res.data.searchParam;

                    this.$nextTick(() => {
                        this.$refs.GridId.addRowClassName(this.totalCount-1, 'subTotal');
                    });

                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
            });
        },
        // 컨텐츠 클릭 이벤트 -> Grid
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
        },
        // 엑셀 다운로드
        excelDownload() {
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    let param = this.getSearchParams();
                    param.excelFileName = 'MonthlyQnaStatus';
                    param.dynQueryId    = 'selectMonthlyQnaStatuses';

                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/monthlyQnaCommonsExcel.skp`,
                            qs.stringify(param),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        // 그리드 컬럼 재정의
        refineColumns() {
            let toMonth = this.TO_DATE.getDate() ? moment(this.TO_DATE.getDate()).formatWithJDF(moment().toMomentFormatString('yyyyMM')) : '';
//            let toMonth2 = moment(this.TO_DATE.getDate(), 'yyyyMM').format('yyyyMM').toString();
            let year1 = toMonth.substring(0, 4);
            let year0 = String(Number(year1) - 1);

            this.gridData = [];
            let cntWid = 100;

            let colNames = [];
            let monAft = 12;
            for (let i=0; i<13; i++) {
                if (String(monAft).length == 1 ) {
                    monAft = '0' + monAft;
                }
                colNames.push('MON_' + monAft);
                monAft = Number(monAft) - 1;
            }
            this.gridHeader = {
                height: 60,
                complexColumns: [
                    {
                        header: 'Year',
                        name: 'mergeColumn1',
                        childNames: ['YEAR_1', 'YEAR_0']
                    },
                    {
                        header: 'Month',
                        name: 'mergeColumn2',
                        childNames: colNames
                    },
                ]
            };

            // Base columns
            this.columns = [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY'),
                    name: "SUBSIDIARY_NM",
                    renderer: {type: TooltipRenderer },
                    sortable: false,
                    resizable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'),
                    name: "STATUS_NM",
                    renderer: {type: TooltipRenderer },
                    sortable: false,
                    resizable: true
                },
                {
                    header: year1,
                    name: "YEAR_1",
                    align: 'center',
                    width: 55,
                    sortable: false,
                    resizable: true
                },
                {
                    header: year0,
                    name: "YEAR_0",
                    align: 'center',
                    width: 55,
                    sortable: false,
                    resizable: true
                }
            ];

            let year2 = Number(year0.substring(2, 4));
            let mon = Number(toMonth.substring(4, 6));
            for (let i=0; i<13; i++) {
                if (String(mon).length == 1 ) {
                    mon = '0' + mon;
                }
                let header = '\'' + year2 + '.' + mon;
                let col = {
                    header: header,
                    name: colNames[i],
                    width: 55,
                    align: 'center',
                    sortable: false,
                    resizable: true
                }
                this.columns.push(col);

                mon = Number(mon) + 1;
                if (mon > 12) {
                    year2 = Number(year2) + 1;
                    mon = 1;
                }
            }
            this.gridKey += 1;
        },
        registVerifyContents() {
            let validList = [''];
            if (SDLUtil.isNull(this.TO_DATE.getDate())) validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if (validList.length > 1) {
                SDLUtil.alert({
                    msg: 'The following fields are required to start search.' + '<br/>' + '<span class="txt_color1">' + 'Period' + '</span>',
                    class: 'sm_size'
                });
                return false;
            } else {
                return true;
            }
        }
    },
/*    
    watch: {
        toMonth () {
            console.log('toMonth ===> ', this.toMonth);;
        }
    },
*/    
    created() {
//        this.refineColumns();
        // 초기 카테고리1 리스트 로드
    },
    mounted() {
        // Subsidiary
        this.loadSubsiCodes(1, '');

        this.$nextTick(() => {
            this.TO_DATE   = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', { type: 'month'} , new Date());
            setTimeout(() => { this.refineColumns(); }, 500);
        });
    },
    beforeDestroy() {

    }
};
</script>

<style>
.zindex9999 { z-index: 99999999; }
.ftColor { color: dodgerblue!important; font-weight: bold!important; cursor:pointer; }
.ftBold {font-weight: bold!important;}
.subTotal {
  background: #f9f9f9 !important;
  font-weight: bold;
  width: 100% !important;
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/monthlyQnAStatusList.vue